import Vue from "vue";
import VueRouter from "vue-router";

import store from "../store";
import store2 from "@/stores";

Vue.use(VueRouter);

const routes = [
  // {
  //   path: '/login',
  //   name: 'account.login',
  //   component: LoginView
  // },
  {
    path: "/",
    name: "root",
    component: () =>
      import(/* webpackChunkName: "home" */ "../views/HomeView.vue"),
    children: [
      {
        path: "/",
        name: "landing",
        component: () =>
          import(/* webpackChunkName: "landing" */ "../views/LandingView.vue")
      }
    ]
  },
  {
    path: "*",
    name: "404",
    redirect: "/"
  }
];

const router = new VueRouter({
  mode: "history",
  base:
    process.env.NODE_ENV === "development"
      ? "/cathayfitback/"
      : "/ODBA/cathayfitback/",
  routes
});

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);
  if (to.name != from.name) {
    store.commit("SET_LOADING_STATUS", true);
  }

  next();
  const qryString = to.query;
  if (
    qryString &&
    (qryString.utm_source ||
      qryString.utm_medium ||
      qryString.utm_campaign ||
      qryString.utm_term ||
      qryString.utm_content)
  ) {
    const reqMap = to.query;
    reqMap.next_page = to.name;
    reqMap.curr_page = from.name;
    reqMap.client_device = isMobile();
    store2.dispatch("insertUTM", reqMap);
  } else {
    store2.dispatch("insertLog", {
      client_device: isMobile(),
      curr_page: from.name,
      next_page: to.name
    });
  }
});

function isMobile() {
  if (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    )
  ) {
    return "Mobile";
  }

  return "Desktop";
}

export default router;
